import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveCr2Failure, saveCr2Success, updateCr2Failure, updateCr2Success } from './actions';

export function* saveCr2({ payload }) {
  try {
    yield call(api.post, 'api/cr2', payload.data, { withCredentials: true });

    yield put(saveCr2Success());

    toast.success('CR2 criado com sucesso!')

    history.push('/specifications/pilar3/resources/cr2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCr2Failure());
  }
}

export function* updateCr2({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/cr2/${id}`, payload.data, { withCredentials: true });

    yield put(updateCr2Success());

    toast.success('CR2 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/cr2');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCr2Failure());
  }
}

export default all([
  takeLatest('@cr2/SAVE_REQUEST', saveCr2),
  takeLatest('@cr2/UPDATE_REQUEST', updateCr2)
]);